const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic — bidirectional (triggers on scroll up AND down)
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      elementTarget.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      if (elementTarget.hasAttribute('data-cascade'))
        elementTarget.setAttribute('style', `--animation-order: ${index};`);
      // Do NOT unobserve — keeps watching so animation re-triggers on re-entry
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* ============================================================
   AUROVRA — Reveal au scroll  (.aurovra-reveal → .is-revealed)
   + Science section pinned scroll (cartes une par une)
   ============================================================ */

(function () {
  'use strict';

  /* ── 1. REVEAL GÉNÉRAL ── */
  function initReveal(root) {
    root = root || document;
    var els = Array.prototype.slice.call(root.querySelectorAll('.aurovra-reveal:not(.is-revealed)'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        o.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── 2. SCIENCE — PINNED SCROLL ── */
  function initSciencePinned() {
    var section = document.querySelector('.aurovra-science--pinned');
    if (!section) return;

    var cards   = Array.prototype.slice.call(section.querySelectorAll('[data-science-card]'));
    var ctaWrap = section.querySelector('[data-science-cta]');
    if (!cards.length) return;

    var segments = [
      [0.05, 0.28],
      [0.35, 0.58],
      [0.65, 0.85]
    ];

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

    function getProgress() {
      var rect    = section.getBoundingClientRect();
      var wh      = window.innerHeight;
      var total   = rect.height - wh;
      var scrolled = -rect.top;
      return clamp(scrolled / total, 0, 1);
    }

    function update() {
      var p = getProgress();

      cards.forEach(function (card, i) {
        var seg   = segments[i] || [0, 0.3];
        var local = (p - seg[0]) / (seg[1] - seg[0]);
        var t     = easeOutCubic(clamp(local, 0, 1));

        card.style.opacity   = t;
        card.style.transform = 'translateY(' + Math.round(80 * (1 - t)) + 'px)';

        if (t >= 0.99 && !card.classList.contains('card-done')) {
          card.classList.add('card-done');
        }
      });

      if (ctaWrap) {
        var lt = easeOutCubic(clamp((p - 0.87) / 0.08, 0, 1));
        ctaWrap.style.opacity   = lt;
        ctaWrap.style.transform = 'translateY(' + Math.round(16 * (1 - lt)) + 'px)';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ── INIT ── */
  function init(root) {
    initReveal(root);
    initSciencePinned();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:reorder', function () { init(); });
  }

})();
